import React from "react";
import { Col, Row } from "antd";
import { DoCCard } from "components/Molecules/cards";
import isEmpty from "lodash/isEmpty";
import merge from "lodash/merge";

type DoCsProps = {
  hidden?: boolean;
  disabled?: boolean;
  value?: any[];
  defaultValue: Array<Record<string, any>>;
  onClickEdit: (
    docName: string,
    docItem: Record<string, any>,
    record: Record<string, any>
  ) => void;
  items: Array<{
    title: string;
    name: string;
    fields: Array<{
      name: string;
      label: string;
    }>;
  }>;
};

export const DoCs = (props: DoCsProps) => {
  const { value, defaultValue, items = [], disabled } = props;
  const mergedValue = React.useMemo(() => {
    if (!value || !value.length) {
      return merge(defaultValue, value || []);
    }
    return value.reduce((acc, current) => {
      const existed = acc.findIndex(({ title }) => {
        return title === current.title;
      });
      if (existed > -1) {
        acc[existed] = merge(acc[existed], current);
      } else {
        acc.push(current);
      }
      return acc;
    }, defaultValue);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  return (
    <div>
      <Row gutter={[16, 16]} hidden={props.hidden}>
        {items.map((docItem) => {
          return (
            <Col span={8} sm={12} xs={24} md={8} key={docItem.name}>
              <DoCCard
                disabled={disabled}
                onClickEdit={(record) => {
                  props.onClickEdit(docItem.name, docItem, record);
                }}
                data={
                  mergedValue.find(({ title }) => title === docItem.title) || {}
                }
                title={docItem.title}
                defaultPlaceHolder="-"
                fields={docItem.fields}
              ></DoCCard>
            </Col>
          );
        })}
      </Row>
    </div>
  );
};
